<template>
  <div>
    <v-dialog
      v-model="takePhotoModal"
      persistent
      max-width="600px"
    >
      <v-card
        flat
        class="px-4 py-2"
      >
        <div class="row">
          <!-- <div
            class="col-12 mb-1 text-center"
            style="font-size: 16px"
          >
            <b>Order ID: {{ orderData.theOrderID }}</b>
          </div> -->

          <div class="col-12 text-center" style="overflow: hidden; width: 440px; height: 250px; margin: 0 auto;">
            <video
              id="video"
              width="440"
              height="250"
              autoplay
              :style="{ transform: `scale(${zoom})` }"
            ></video>
          </div>

          <div class="col-12 mb-2 text-center">
            <div class="d-flex align-items-center justify-content-center">
              <v-slider
                  v-model="zoom"
                  :min="1"
                  :max="3"
                  :step="0.1"
                  thumb-label
                  style="flex: 1;"
                ></v-slider>
            </div>
          </div>

          <div class="col-12 mb-4 text-center">
            <v-btn
              style="height:auto"
              outline
              color="primary"
              small
              @click="takePhoto()"
            >
              Take Photo
            </v-btn>
          </div>

          <div
            class="col-6 col-sm-6 col-md-3 col-lg-3 col-xl-3 mb-2"
            v-for="(photo, phIndex) in displayPhotos"
            :key="phIndex"
            style="position: relative"
          >
            <i
              class="fa fa-times fa-2x"
              style="position: absolute; top: -10px; right: 0px; color: #EF5350; cursor: pointer"
              @click="removeImage(phIndex)"
            ></i>
            <img
              :src="photo"
              alt="Image"
              width="100%"
              height="120px"
              style="margin-bottom: 10px"
            >
          </div>

          <div
            class="col-12"
            style="display: none"
          >
            <canvas
              v-if="showCanvas"
              id="canvas"
              width="350"
              height="250"
            ></canvas>
          </div>
        </div>

        <v-card-actions>
          <a
            id="downloadPhoto"
            :download="`Order #${orderData.theOrderID}.jpg`"
            class="btn white"
            style="box-shadow: none; border: 1px solid #FFB74D !important; color: #FFB74D; display: none"
            :style="!photoExist ? 'pointer-events: none' : ''"
            role="button"
            @click="downloadImage()"
          >
            Download
          </a>
          <v-btn
            style="height:auto"
            @click="newPhoto()"
            outline
            small
          >Open Camera</v-btn>
          <v-btn
            style="height:auto; margin-left: 8px"
            @click="flipCamera()"
            outline
            small
            color="primary"
          >Flip Camera</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            style="height:auto"
            @click="closeDialog()"
            outline
            small
            color="normal"
          >Cancel</v-btn>
          <v-btn
            style="height:auto; margin-right: 4%"
            color="success"
            depressed
            outline
            small
            :disabled="takenPhotos.length < 1"
            @click="saveImage()"
          >Save</v-btn>
        </v-card-actions>

        <div class="row">
          <div
            class="col-12 green lighten-1 py-1 px-3"
            style="font-size: 16px; color: #fff; border-radius: 4px"
            v-show="showSeccessMsg"
          >
            Image Saved
          </div>
        </div>
      </v-card>

    </v-dialog>
  </div>
</template>
<script>
import Axios from 'axios'
export default {
  props: {
    takePhotoModal: { type: Boolean, default: false },
    orderData: { type: Object, default: () => { } },
    url: { type: String, default: 'api/order_image' },
    filenameKey: { type: String, default: 'order_image' },
    modelFk: { type: String, default: 'order_id_fk' },
    modelPk: { type: String, default: 'order_id' }
  },

  data() {
    return {
      showCanvas: true,
      showSeccessMsg: false,
      photoExist: false,
      takenPhotos: [],
      displayPhotos: [],
      facingMode: 'user', // 'user' for front camera, 'environment' for rear camera
      zoom: 1 // Zoom level from 1 to 3
    }
  },

  watch: {
    takePhotoModal: {
      immediate: false,
      handler() {
        if (this.takePhotoModal) {
          this.openCamera()
        }
      }
    }
  },

  methods: {
    closeDialog() {
      this.showCanvas = false
      setTimeout(() => {
        this.showCanvas = true
        this.$emit('close')
      }, 200)
    },

    newPhoto() {
      this.showCanvas = false
      this.openCamera()
      setTimeout(() => {
        this.showCanvas = true
      }, 500)
    },

    openCamera() {
      var video = document.getElementById('video')

      // Get access to the camera!
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        // Not adding `{ audio: true }` since we only want video now
        navigator.mediaDevices.getUserMedia({ video: { facingMode: this.facingMode } }).then(function (stream) {
          // video.src = window.URL.createObjectURL(stream)
          video.srcObject = stream
          video.play()
        })
      }
    },

    flipCamera() {
      // Toggle between front and rear camera
      this.facingMode = this.facingMode === 'user' ? 'environment' : 'user'

      // Stop current stream and restart with new facing mode
      var video = document.getElementById('video')
      if (video.srcObject) {
        let tracks = video.srcObject.getTracks()
        tracks.forEach((track) => {
          track.stop()
        })
      }
      this.openCamera()
    },

    takePhoto() {
      var canvas = document.getElementById('canvas')
      var context = canvas.getContext('2d')
      var video = document.getElementById('video')

      // Clear canvas
      context.clearRect(0, 0, canvas.width, canvas.height)

      // Apply zoom by scaling and centering
      context.save()
      const scaledWidth = 350 * this.zoom
      const scaledHeight = 250 * this.zoom
      const offsetX = (scaledWidth - 350) / 2
      const offsetY = (scaledHeight - 250) / 2

      context.drawImage(video, -offsetX, -offsetY, scaledWidth, scaledHeight)
      context.restore()

      let ph = this.getTakenPhoto()
      this.takenPhotos.push(ph)

      this.displayPhotos.push(this.getPhotoForDisplay(ph))

      // this.newPhoto()
    },

    getPhotoForDisplay(file) {
      return URL.createObjectURL(file)
    },

    removeImage(index) {
      this.takenPhotos.splice(index, 1)
      this.displayPhotos.splice(index, 1)
    },

    // downloadImage() {
    //     const download = document.getElementById('downloadPhoto')
    //     const canvas = document.getElementById('canvas').toDataURL('image/jpeg')
    //     download.setAttribute('href', canvas)
    // },

    getTakenPhoto() {
      const download = document.getElementById('downloadPhoto')
      const canvas = document.getElementById('canvas').toDataURL('image/jpeg')
      download.setAttribute('href', canvas)

      // Convert dataUrl to File
      let arr = canvas.split(',')
      let mime = arr[0].match(/:(.*?);/)[1]
      let bstr = atob(arr[1])
      let n = bstr.length
      let u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], this.filenameKey + Math.floor(Date.now() / 1000), { type: mime })
    },

    saveImage() {
      let formData = new FormData()
      this.takenPhotos.forEach((ph) => {
        formData.append(`${this.filenameKey}[]`, ph)
      })
      formData.append(this.modelFk, this.orderData[this.modelPk])

      let token = localStorage.getItem('access_token')
      Axios.post(this.url, formData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(() => {
        this.showSeccessMsg = true
        this.takenPhotos = []
        this.displayPhotos = []
        this.$emit('photo-saved')
        setTimeout(() => {
          this.showSeccessMsg = false
          this.closeDialog()
        }, 1000)
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/takePhoto.vue